module.exports = __webpack_public_path__ + "static/media/COS_SICOBEL.5503d7d2.jpg";